import { ModelStatus } from './model-status';

export interface SelectionItem {
    id: number;
    name: string;
    value: string;
    modelStatus: number;
}

export function createSelectionItem(id: number, name: string, value: string, modelStatus: ModelStatus = ModelStatus.NONE): SelectionItem {
    return {
        id: id,
        name: name,
        value: value,
        modelStatus: modelStatus
    };
}
